export default "<a (click)=\"this.arrowClicked()\" [ngClass]=\"{'reached-bottom': this.reachedBottom}\"></a>"